import styled from 'styled-components';
import { motion } from 'framer-motion';
import MuiDialog from '@mui/material/Dialog';
import { Themes } from '../../style/theme-consts';
import { monitor } from '../../utils/media-consts';

export const HEIGHT = '166px';

export const Container = styled.div.attrs({ className: `dsc-cardLayout ${Themes.DARK}` })`
  display: flex;
  flex-direction: column;
  gap: var(--medium-gap);
  height: 100%;
`;

export const HeaderSection = styled.div.attrs({ className: 'dsc-cardLayoutHeaderSection' })`
  position: relative;
`;

export const CollapsibleHeaderWrapper = styled(motion.div).attrs({
  className: 'dsc-cardLayoutHeader',
  transition: { duration: 0.3, ease: 'easeInOut' }
})`
  overflow: hidden;
`;

export const TabsSection = styled.div.attrs({ className: 'dsc-cardLayoutTabsSection' })`
  position: relative;
`;

export const ContentSection = styled.div.attrs({ className: 'dsc-cardLayoutContentSection' })`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const CollapseToggle = styled.div.attrs({ className: 'dsc-cardLayoutCollapseToggle' })`
  display: flex;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 25px;
  border: var(--page-toggle-border);
  border-radius: var(--page-toggle-radius);
  background-color: var(--page-toggle-bg);
  box-shadow: var(--page-toggle-shadow);
  cursor: pointer;
  z-index: 13;

  .collapse-icon svg {
    color: var(--page-toggle-icon-color);
    transition: transform 0.3s ease-in-out;
    transform: ${({ $expanded }) => ($expanded ? 'rotate(90deg)' : 'rotate(270deg)')};
  }
`;

export const DialogWrapper = styled(MuiDialog).attrs({ className: 'dsc-cardLayoutDialog' })`
  .MuiPaper-root {
    width: ${({ fullScreen }) => (fullScreen ? '100%' : '82vw')};
    height: ${({ fullScreen }) => (fullScreen ? '100%' : '75vh')};
    border-radius: var(--main-card-radius);

    @media ${monitor.gte_extraLarge} {
      width: ${({ fullScreen }) => (fullScreen ? '100%' : '75vw')};
      height: ${({ fullScreen }) => (fullScreen ? '100%' : '68vh')};
    }
  }

  && {
    .MuiDialogContent-root {
      padding: 24px 24px 0;
      overflow: hidden;
      height: 100%;
      background-color: var(--mainModalCanvasColor);
    }
  }
`;

export const ToolbarWrapper = styled.div.attrs({ className: Themes.DARK })`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 24px;
  justify-content: flex-end;

  > div {
    cursor: pointer;
  }
`;

export const SkeletonContainer = styled.div`
  display: flex;
  gap: 32px;
  height: ${HEIGHT};
  justify-content: center;

  div {
    display: flex;
    flex-direction: column;
    gap: 18px;
    align-items: center;
    justify-content: center;
    padding-block: 27px;
  }

  .MuiSkeleton-pulse {
    background-color: var(--skeleton-bg-color);
  }
`;
